// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, takeEvery, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_REVENUE = "saga/FETCH_REVENUE";
export const FETCH_REVENUE_SUCCESS = "saga/FETCH_REVENUE_SUCCESS";
export const FETCH_REVENUE_FAILURE = "saga/FETCH_REVENUE_FAILURE";
export const FETCH_REVENUE_BY_TYPE = "saga/FETCH_REVENUE_BY_TYPE";
export const FETCH_REVENUE_BY_TYPE_SUCCESS = "saga/FETCH_REVENUE_BY_TYPE_SUCCESS";
export const FETCH_REVENUE_BY_TYPE_FAILURE = "saga/FETCH_REVENUE_BY_TYPE_FAILURE";
export const FETCH_YEAR_OVER_YEAR = "saga/FETCH_YEAR_OVER_YEAR";
export const FETCH_YEAR_OVER_YEAR_SUCCESS = "saga/FETCH_YEAR_OVER_YEAR_SUCCESS";
export const FETCH_YEAR_OVER_YEAR_FAILURE = "saga/FETCH_YEAR_OVER_YEAR_FAILURE";
export const REMOVE_REVENUE_CATEGORY = "saga/REMOVE_REVENUE_CATEGORY";
export const REMOVE_REVENUE_CATEGORY_FAILURE = "saga/REMOVE_REVENUE_CATEGORY_FAILURE";
export const REMOVE_REVENUE_CATEGORY_SUCCESS = "saga/REMOVE_REVENUE_CATEGORY_SUCCESS";
export const ADD_REVENUE_CHART = "saga/ADD_REVENUE_CHART";
export const ADD_REVENUE_CHART_SUCCESS = "saga/ADD_REVENUE_CHART_SUCCESS";
export const ADD_REVENUE_CHART_FAILURE = "saga/ADD_REVENUE_CHART_FAILURE";
export const SET_REVENUE_TYPES_CHECKED = "saga/SET_REVENUE_TYPES_CHECKED";
export const SET_REVENUE_TYPES_CHECKED_SUCCESS = "saga/SET_REVENUE_TYPES_CHECKED_SUCCESS";
export const SET_REVENUE_TYPES_CHECKED_FAILURE = "saga/SET_REVENUE_TYPES_CHECKED_FAILURE";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  fetchRevenue: createAction(FETCH_REVENUE),
  fetchRevenueByType: createAction(FETCH_REVENUE_BY_TYPE),
  fetchYearOverYear: createAction(FETCH_YEAR_OVER_YEAR),
  removeRevenueCategory: createAction(REMOVE_REVENUE_CATEGORY),
  addRevenueChart: createAction(ADD_REVENUE_CHART),
  setRevenueTypesChecked: createAction(SET_REVENUE_TYPES_CHECKED)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(FETCH_REVENUE, getRevenueData);
  yield takeLatest(FETCH_REVENUE_BY_TYPE, getRevenueByTypeData);
  yield takeLatest(FETCH_YEAR_OVER_YEAR, getYearOverYearData);
  yield takeEvery(REMOVE_REVENUE_CATEGORY, removeRevenueCategory);
  yield takeLatest(ADD_REVENUE_CHART, addRevenueChart);
  yield takeLatest(SET_REVENUE_TYPES_CHECKED, setRevenueTypesChecked);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });

  date = data.payload.date || (yield select(state => state.revenue.currentUser.calendarEndDate));

  const id = yield select(state => state.revenue.currentUser.organization_id);
  const objectId = yield select(state => state.revenue.currentUser.current_object_id);
  const locationId = yield select(state => state.revenue.currentUser.current_location_id);
  const regionId = yield select(state => state.revenue.currentUser.current_region_id);

  const allSagas = [
    getRevenueData(id, objectId, locationId, regionId, date),
    getRevenueByTypeData(id, objectId, locationId, regionId, date),
    getYearOverYearData(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData(month) {
  yield put({ type: SET_LOADING, payload: true });

  date = month.payload;

  const id = yield select(state => state.revenue.currentUser.organization_id);
  const objectId = yield select(state => state.revenue.currentUser.current_object_id);
  const locationId = yield select(state => state.revenue.currentUser.current_location_id);
  const regionId = yield select(state => state.revenue.currentUser.current_region_id);

  const allSagas = [
    getRevenueData(id, objectId, locationId, regionId, date),
    getRevenueByTypeData(id, objectId, locationId, regionId, date),
    getYearOverYearData(id, objectId, locationId, regionId, date)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueData(id, objectId, locationId, regionId, date) {
  try {
    const revenueResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "revenues/totals" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_REVENUE_SUCCESS, payload: revenueResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_REVENUE_FAILURE, error });
  }
}

export function* getRevenueByTypeData(id, objectId, locationId, regionId, date) {
  try {
    const revenueByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "revenues/revenues_by_type" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_REVENUE_BY_TYPE_SUCCESS, payload: revenueByTypeResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_REVENUE_BY_TYPE_FAILURE, error });
  }
}

export function* getYearOverYearData(id, objectId, locationId, regionId, date) {
  try {
    const yearOverYearResponse = yield call(
      axios.get,
      queryParams.apiVersion +
        "revenues/year_over_year_revenues" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_YEAR_OVER_YEAR_SUCCESS, payload: yearOverYearResponse.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_YEAR_OVER_YEAR_FAILURE, error });
  }
}

export function* removeRevenueCategory() {
  const charts = yield select(state => state.revenue.revenuesByType);

  const chartsToPush = [];
  charts.map(items => {
    chartsToPush.push(items.id);
  });

  const id = yield select(state => state.revenue.currentUser.organization_id);
  const objectId = yield select(state => state.revenue.currentUser.current_object_id);
  const locationId = yield select(state => state.revenue.currentUser.current_location_id);
  const regionId = yield select(state => state.revenue.currentUser.current_region_id);
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "revenues/set_default_revenue_type_ids" +
        "?default_revenue_type_ids[]=" +
        chartsToPush[0] +
        "&default_revenue_type_ids[]=" +
        chartsToPush[1] +
        "&default_revenue_type_ids[]=" +
        chartsToPush[2] +
        "&default_revenue_type_ids[]=" +
        chartsToPush[3] +
        "&organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "" +
        "&date=" +
        date
    );
    yield put({ type: REMOVE_REVENUE_CATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: REMOVE_REVENUE_CATEGORY_FAILURE, error });
  }
}

export function* setRevenueTypesChecked(action) {
  try {
    yield put({ type: SET_REVENUE_TYPES_CHECKED_SUCCESS, payload: action.payload });
  } catch (error) {
    console.error(error);
    yield put({ type: SET_REVENUE_TYPES_CHECKED_FAILURE, error });
  }
}

export function* addRevenueChart() {
  const id = yield select(state => state.revenue.currentUser.organization_id);
  const objectId = yield select(state => state.revenue.currentUser.current_object_id);
  const locationId = yield select(state => state.revenue.currentUser.current_location_id);
  const regionId = yield select(state => state.revenue.currentUser.current_region_id);
  const chartId = yield select(state => state.revenue.revenueTypesChecked);
  try {
    const response = yield call(
      axios.put,
      queryParams.apiVersion +
        "revenues/set_default_revenue_type_ids" +
        "?default_revenue_type_ids[]=" +
        chartId[0] +
        "&default_revenue_type_ids[]=" +
        chartId[1] +
        "&default_revenue_type_ids[]=" +
        chartId[2] +
        "&default_revenue_type_ids[]=" +
        chartId[3] +
        "&organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "" +
        "&date=" +
        date
    );
    yield put({ type: ADD_REVENUE_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: ADD_REVENUE_CHART_FAILURE, error });
  }
}
